import { DatePipe } from '@angular/common';
import { NgModule, ModuleWithProviders, Optional, SkipSelf } from '@angular/core';
import { Globals } from '../services/globals';
import { UtilityService } from '../services/utility.service';

@NgModule({
    imports: [],
    declarations: [],
    exports: [],
    providers: [DatePipe]
})

export class SharedProviderModule {
    public static forRoot(): ModuleWithProviders<SharedProviderModule> {
        return {
            ngModule: SharedProviderModule,
            providers: [
                Globals,
                UtilityService
            ]
        };
    }

    constructor(@Optional() @SkipSelf() parentModule: SharedProviderModule) {
        if (parentModule) {
            throw new Error('SharedModule is already loaded. Import it in the AppModule only');
        }
    }
}
